import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { Button } from "@mui/material";
import {
  DataGridPro,
  GridToolbarContainer,
  GridToolbarExport,
} from "@mui/x-data-grid-pro";
import { AddIcon } from "../../components/icons";

import {
  useDispatch,
  adminActions,
  useSelector,
  adminSelectors,
} from "../../state";
import AdminPages from ".";
import { STATES_COLUMNS as columns } from "../../constants/tables";

import { useStyles } from "./StatesPage.styles";

function CustomToolbar() {
  return (
    <GridToolbarContainer>
      <GridToolbarExport />
    </GridToolbarContainer>
  );
}
export default function StatesPage() {
  const classes = useStyles();
  const dispatch = useDispatch();

  const [pageSize, setPageSize] = React.useState(25);

  const states = useSelector(adminSelectors.states);

  useEffect(() => {
    dispatch(adminActions.getStates());
    dispatch(adminActions.setPageTitle("Supported States"));
  }, [dispatch]);

  return (
    <div
      style={{
        height: 650,
        width: "100%",
      }}
    >
      <div className={classes.topArea}>
        <Link className={classes.link} to={AdminPages.createStates.path}>
          <Button variant="outlined" color="primary">
            <AddIcon /> Add State
          </Button>
        </Link>
      </div>

      <DataGridPro
        rows={states}
        columns={columns}
        pagination
        pageSize={pageSize}
        onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
        rowsPerPageOptions={[10, 25, 50, 100]}
        components={{
          Toolbar: CustomToolbar,
        }}
      />
    </div>
  );
}
